<template>
  <main class="support-chat-page safe-page">
    <AppNavBar :title="t('mine.onlineSupport')" />
    <iframe :src="chatUrl" class="support-chat-frame" title="support-chat" />
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useThemeStore } from "@/stores/theme";

const themeStore = useThemeStore();
const { t } = useI18n();
const chatUrl = computed(
  () =>
    themeStore.url?.customUrl ||
    "https://tawk.to/chat/69ba019878528f1c3500094b/1jjv9cfnu",
);
</script>

<style scoped lang="scss">
.support-chat-page {
  min-height: var(--app-viewport-height);
  background: #f5f5f5;
}

.support-chat-frame {
  display: block;
  width: 100%;
  height: calc(var(--app-viewport-height) - var(--van-nav-bar-height, 46px));
  border: 0;
  background: #f5f5f5;
}
</style>
